import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWhiteboard2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconWhiteboard2"><Path d="M12.7502 2.5H11.2502V4H2V5.5H3V18.5H2.00049V20H22V18.5H21V5.5H22V4H12.7502V2.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWhiteboard2;
